import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ReactDOM from 'react-dom';
//using reactDom for Deploying this project

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
